import React, { useState, useEffect, useCallback } from "react";
//outsource
import { Row, Col, Layout, Button, Spin } from "antd";
import { URL } from "../00_Nav/url";
//components
// import LayoutBreadCrum from "../00_Nav/layout/layout_bread_crum";
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import LayoutHeader from "../00_Nav/layout/layout_header";
import RosterTopBar from "./component/roster_top_bar";
import RosterTable from "./component/roster_table";

import dateArray from "moment-array-dates";
import moment from "moment";
import lodash from "lodash";
//redux
import { useDispatch, useSelector } from "react-redux";
//action
// import { setHighlight } from "../../store/nav/nav.action";
import { snapBranchs, unSnapBranchs } from "../../store/branch/branch.action";
import { snapAllUsers, unSnapUsers } from "../../store/user/user.action";
// import { snapAllStaffs, unSnapStaffs } from "../../store/staff/staff.action";
import {
  snapLockRoster,
  unSnapLockRoster,
  snapRoster,
  unSnapRoster,
  lockRoster,
  copyRosterLastWeek,
  deleteRosterThisWeek,
} from "../../store/roster/roster.action";
//selector
import { branchsSelector } from "../../store/branch/branch.selector";
// import { createSampleData } from "../../store/dev/dev.action";
import {
  lockRosterSelector,
  rosterSelector,
} from "../../store/roster/roster.selector";

import "./style.css";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import { UnSnapAllStaff, snapAllStaffs } from "../../store/staff/staff.action";

const { Content } = Layout;

const formatDate = "ddd DD MMM YYYY";

const RosterScreen = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Roster", url: URL.roster },
  ];
  // -------------------------- STATE --------------------------

  const [loading, setLoading] = useState(false);
  const [copying, setCopying] = useState(false);
  const [error, setError] = useState(false);
  const [from, setFrom] = useState(moment().startOf("week"));
  const [to, setTo] = useState(moment().endOf("week"));
  const [fillUp, setFillUp] = useState(false);
  const [dates, setDates] = useState(
    dateArray.range(
      moment().startOf("week"),
      moment().endOf("week"),
      formatDate,
      true
    )
  );
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branchs = useSelector(branchsSelector);
  const rosters = useSelector(rosterSelector);
  const lock = useSelector(lockRosterSelector);
  // rosrer by staff
  const rosterByStaff = lodash.groupBy(rosters, "staff");

  // -------------------------- FUNCTION --------------------------

  const handleWeekChange = (date) => {
    if (date) {
      const from = moment(date)?.startOf("week");
      const to = moment(date)?.endOf("week");
      const dates = dateArray.range(from, to, formatDate, true);

      setFrom(from);
      setTo(to);
      setDates(dates);
    }
  };

  const handlecopyRosterLastWeek = () => {
    if (from && to) {
      setCopying(true);
      // setLoading(true);
      if (!lock) {
        dispatch(lockRoster({ from, to }));
      }
      dispatch(
        deleteRosterThisWeek({ from, to }, () => {
          dispatch(
            copyRosterLastWeek({ from, to }, () => {
              setCopying(false);
              // setLoading(false);
            })
          );
        })
      );
    }
  };
  const lockCurrentWeek = () => {
    if (from && to && !lock) {
      dispatch(lockRoster({ from, to }));
    }
  };

  // -------------------------- EFFECT --------------------------

  //snapBranch
  useEffect(() => {
    dispatch(snapBranchs());
    dispatch(snapAllUsers());
    dispatch(snapAllStaffs());

    return () => {
      dispatch(unSnapBranchs());
      dispatch(unSnapUsers());
      dispatch(UnSnapAllStaff());
    };
  }, [dispatch]);

  //snap shot with clear roster
  useEffect(() => {
    if (from && to) {
      setLoading(true);
      dispatch(snapLockRoster({ from, to }));
      dispatch(
        snapRoster({ from, to }, () => {
          setLoading(false);
        })
      );
    }

    return () => {
      dispatch(unSnapRoster());
      dispatch(unSnapLockRoster());
    };
  }, [dispatch, from, to]);

  //snap is fill up
  //useEffect này goi mỗi lần rosters thay đổi đổi(snap),
  //khi copy roster của shop shop--> chạy mỗi lầ recỏd record thêm 1 roster
  // useEffect(() => {
  //   if (branchs && rosters) {
  //     const byBranchs = lodash.groupBy(rosters, "branch");
  //     const size = byBranchs && Object.keys(byBranchs)?.length;
  //     const filledUp = branchs && branchs?.length === size;
  //     // console.log({ byBranchs, branchs, size });
  //     setFillUp(filledUp);
  //   }
  // }, [branchs, rosters]);

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col />
        <Col xl={24} lg={24} md={24} xs={24}>
          <RosterTopBar
            handleWeekChange={handleWeekChange}
            copyRosterLastWeek={handlecopyRosterLastWeek}
            fillUp={fillUp}
            lock={lock}
            loading={loading}
            setLoading={setLoading}
            copying={copying}
            from={from}
            to={to}
          />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24} align="center">
          {copying ? (
            <Spin tip="Copying previous week roster..."></Spin>
          ) : (
            renderRoster()
          )}
        </Col>
      </Row>
    );
  };

  const renderRoster = () => {
    if (branchs) {
      // sort branches
      const shopIds = [
        "PN_SL_1",
        "PN_SL_2",
        "PN_NM",
        "NS_NM",
        "NS_SL",
        "PN_BRI",
        "HOBSON",
        "PN_BTN",
      ];
      const sorted = lodash.sortBy(branchs, (item) =>
        lodash.indexOf(shopIds, item?.shopId)
      );
      return (
        <Row gutter={[20, 20]}>
          {sorted?.map((item, index) => renderRosterTable({ item, index }))}
        </Row>
      );
    }

    return null;
  };

  const renderRosterTable = ({ item, index }) => {
    return (
      <Col
        key={index}
        xl={12}
        lg={12}
        md={24}
        xs={24}
        style={{ marginBottom: 40 }}
      >
        <RosterTable
          branch={item}
          dates={dates}
          copying={copying}
          loading={loading}
          lockCurrentWeek={lockCurrentWeek}
          rosterByStaff={rosterByStaff}
        />
      </Col>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default RosterScreen;
